import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { OilBlockDto, OilFieldDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-oil-field-view',
  templateUrl: './oil-field-view.component.html',
  styleUrls: ['./oil-field-view.component.css'],
})
export class OilFieldViewComponent implements OnInit {
  @Input() oilBlocks: OilBlockDto[];
  @Input() oilFields: OilFieldDto[];
  oilFieldForm: FormGroup;
  control = new FormControl();
  @Output() changeEmit = new EventEmitter<OilFieldDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  selectedOilBlock: any;
  filteredDelete: Array<any> = [];
  loading = true;
  filteredOilFields: Array<any> = [];
  status: boolean;
  selectedOilBlockId: any;
  LabelName: string;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.oilFieldForm = this.fb.group({ OilFields: this.fb.array([]) });
  }

  // method to display countries
  setOilField() {
    const control = this.oilFieldForm.controls.OilFields as FormArray;
    this.filteredOilFields.forEach((e) => {
      control.push(
        this.fb.group({
          OilFieldName: e.OilFieldName,
          LabelName: e.LabelName,
          OilBlockId: e.OilBlockId,
          id: e.id,
        })
      );
    });
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.oilFieldForm.controls.OilFields as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter state
  selectOilField(event: string) {
    this.filteredOilFields = this.oilFields.filter(
      (s) => s.OilBlockId === event
    );
    this.selectedOilBlockId = event;
    const control = this.oilFieldForm.controls.OilFields as FormArray;

    if (this.filteredOilFields.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setOilField();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  // method to add Country
  addOilField() {
    if (this.oilFields.length > 0) {
      this.LabelName = this.oilFields[0].LabelName;
    } else {
      this.LabelName = '';
    }
    const control = this.oilFieldForm.controls.OilFields as FormArray;
    control.insert(
      0,
      this.fb.group({
        OilFieldName: ['', Validators.required],
        LabelName: [this.LabelName],
        OilBlockId: this.selectedOilBlockId,
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete country from arrary list
  deleteOilField(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.oilFieldForm.controls.OilFields as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.oilFields.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.oilFields[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'oilField';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('oilField');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
